import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "ml-3"
}
const _hoisted_3 = { key: 0 }

import {ref, watch} from 'vue'
import {ApiMap} from "@/api/type";
import {useApi} from "@/api/handler";
import {game} from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'InitDelete',
  props: {
    data: {},
    maxHeight: {},
    showDelete: { type: Boolean }
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const scoreList = ref<ApiMap['/game/rank/team/:id']['resp']>([])

const rankColors = ['amber darken-2', 'blue-grey lighten-1', 'deep-orange lighten-1']

const useAllRank = () => {
  if (!GameStatus.value) return
  useApi({
    api: game.TileRank(GameStatus.value.id),
    onSuccess: resp => {
      scoreList.value = resp.data as ApiMap['/game/rank/team/:id']['resp']
    }
  })
}

const useRemoveTeam = (teamId: number, b: boolean) => {
  if (!GameStatus.value) return
  useApi({
    api: game.RemoveTeam({gameId: GameStatus.value.id, teamIds: [teamId], type: b ? 2 : 1}),
    onSuccess: () => {
      useAllRank()
      emits('update')
    }
  })
}

watch(() => props.data, newVal => {
  GameStatus.value = newVal ?? null
  useAllRank()
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    rounded: "",
    "max-height": _ctx.maxHeight ?? 400
  }, {
    default: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-lg-h6 px-4 py-2 bg-indigo-lighten-2" }, " 棋盘赛阶段 - 小组积分排行榜 ", -1)),
      _createElementVNode("div", {
        class: "ml-2",
        style: _normalizeStyle(`overflow-y: auto; height: ${_ctx.maxHeight - 50}px`)
      }, [
        _createVNode(_component_v_table, {
          density: "compact",
          class: "rounded"
        }, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("th", null, "排名", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("th", null, "组号", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("th", null, "姓名", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("th", null, "得分", -1)),
                (_ctx.showDelete)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_1, "操作"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoreList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.teamId
                }, [
                  _createElementVNode("td", null, [
                    (index < 3)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: rankColors[index],
                          "text-color": "white",
                          density: "compact",
                          small: "",
                          label: "",
                          class: "font-weight-bold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 第 " + _toDisplayString(index + 1) + " 名 ", 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_2, "第 " + _toDisplayString(index + 1) + " 名", 1))
                  ]),
                  _createElementVNode("td", null, "第 " + _toDisplayString(item.teamId) + " 组", 1),
                  _createElementVNode("td", null, _toDisplayString(item.leaderName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.totalScore), 1),
                  (_ctx.showDelete)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
                        (item.status === 1)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "text",
                              "prepend-icon": "mdi-delete",
                              class: "pa-0",
                              color: "red-lighten-1",
                              onClick: ($event: any) => (useRemoveTeam(item.teamId, true))
                            }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("淘汰")
                              ])),
                              _: 2,
                              __: [4]
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (item.status === 2)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              variant: "text",
                              "prepend-icon": "mdi-reload",
                              class: "pa-0",
                              color: "green-lighten-1",
                              onClick: ($event: any) => (useRemoveTeam(item.teamId, false))
                            }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode("恢复")
                              ])),
                              _: 2,
                              __: [5]
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ], 4)
    ]),
    _: 1,
    __: [6]
  }, 8, ["max-height"]))
}
}

})